import React, { useEffect } from 'react';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { makeStyles } from '@mui/styles';
import { api } from 'common';
import { useTranslation } from "react-i18next";
import { colors } from '../components/Theme/WebTheme';
import { WEB_MAIN_COLOR, WEB_SECONDORY_COLOR, FONT_FAMILY } from "../common/sharedFunctions";
import AdminWalletCreditForm from '../components/AdminWalletCreditForm';
import { useSearchParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    container: props => ({
        maxWidth: "50vw",
        marginTop: theme.spacing(1),
        backgroundColor: WEB_MAIN_COLOR(props?.settings?.appCat),
        alignContent: 'center',
        borderRadius: "8px",
    }),
    container1: props => ({
        backgroundColor: colors.Header_Text,
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "0px",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px",
        padding: '30px',
        width: '100%',
        top: "19px",
        boxShadow: `0px 2px 5px ${WEB_SECONDORY_COLOR(props?.settings?.appCat)}`,
    }),
    title: {
        color: colors.WHITE,
        padding: '10px',
        fontSize: 18,
        fontFamily: FONT_FAMILY
    },
}));

export default function AddMoney() {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const { fetchUsersOnce } = api;
    const settings = useSelector(state => state.settingsdata.settings);
    const dispatch = useDispatch();
    const classes = useStyles({ settings });
    const [commonAlert, setCommonAlert] = React.useState({ open: false, msg: '' });
    const [searchParams] = useSearchParams();
    const preselectedUid = searchParams.get('uid');
    const isMidScreen = useMediaQuery('(max-width:800px)');

    useEffect(() => {
        dispatch(fetchUsersOnce());
    }, [dispatch, fetchUsersOnce]);

    const handleCommonAlertClose = (e) => {
        e.preventDefault();
        setCommonAlert({ open: false, msg: '' });
    };

    return (
        <div className={classes.container} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr', maxWidth: isMidScreen && "100%" }}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
                <Grid item>
                    <Grid item xs={12}>
                        <Typography className={classes.title} style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left' }}>
                            {t('admin_driver_wallet_title', { defaultValue: 'Recargar billetera del conductor' })}
                        </Typography>
                    </Grid>
                    <div className={classes.container1}>
                        <AdminWalletCreditForm
                            preselectedUid={preselectedUid}
                            defaultFilter="driver"
                            onSuccess={(result) => setCommonAlert({ open: true, msg: result.msg })}
                        />
                    </div>
                </Grid>
            </Grid>
            <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
        </div>
    );
}
